
import { Link } from 'react-router-dom';
import logo from "../../assets/img/logo-2.png";
import subscribeBg from "../../assets/img/page/banner-video.png";
import Social from '../../data/social';
import blogData from '../../data/blog-data';

const FooterTwo = () => {
    return (
        <>
            <div className="footer__two">
                {/* <div className="subscribe__area">
                    <div className="container">
                        <div className="row align-items-center subscribe__area-bg" style={{backgroundImage: `url(${subscribeBg})`}}>
                            <div className="col-lg-6 lg-mb-40 lg-t-center">
                                <div className="subscribe__area-left title_split_anim">
                                    <h2>Begin Your Dream Project Today!</h2>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="subscribe__area-form wow fadeInUp" data-wow-delay=".4s">
                                    <form>
                                        <input type="email" name="email" placeholder="Email address" />
                                        <button className="build_button" type="submit">Subscribe Now</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="container">
                    <div className="row pt-80">
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="footer__two-widget">
                                <div className="footer__two-widget-about">
                                    <Link to="/"><img src={logo} alt="image" /></Link>
                                    <p>Redefining the construction industry with innovative solutions, cuttin-edge technology and sustainable practices</p>

                                    <div className="footer__two-widget-about-social">
                                        <Social />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="footer__two-widget footer-border pl-50 ">
                                <h4>Contacts</h4>
                                <div className="contact__area-left-contact-item pt-20 text-white">
                                    <div className="contact__area-left-contact-item-icon">
                                        <i className="flaticon-phone"></i>
                                    </div>
                                    <div className="contact__area-left-contact-item-content">
                                        <span>Phone:</span>
                                        <h6 className="text-white"><Link to="tel:+880 1704-100300">+880 1704-100300</Link></h6>
                                    </div>
                                </div>
                                
                                <div className="contact__area-left-contact-item text-white">
                                    <div className="contact__area-left-contact-item-icon">
                                        <i className="flaticon-email-3"></i>
                                    </div>
                                    <div className="contact__area-left-contact-item-content">
                                        <span>Email Address:</span>
                                        <h6 className="text-white"><Link to="mailto:theengineersbayltd@gmail.com">theengineersbayltd@gmail.com</Link></h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-12 md-mt-30">
                            <div className="footer__two-widget footer-border pl-60 md-pl-0">
                                <h4>Head Office</h4>
                                <div className="footer__two-widget-location pt-20">
                                    <div className="footer__two-widget-location-item">
                                        <div className="footer__two-widget-location-item-icon">
                                            <i className="flaticon-location"></i>
                                        </div>
                                        <div className="footer__two-widget-location-item-info ml-20">
                                            <Link to="https://www.google.com/maps">House -06, Road 2/A, Block J, Baridhara, Dhaka-1212, Bangladesh</Link>
                                        </div>
                                    </div>
                                    {/* <h6>Branch Office</h6>
                                    <div className="footer__two-widget-location-item">
                                        <div className="footer__two-widget-location-item-icon">
                                            <i className="flaticon-location"></i>
                                        </div>
                                        <div className="footer__two-widget-location-item-info">
                                            <Link to="https://www.google.com/maps">2464 Royal Ln. Mesa, New Jersey 45463</Link>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-4 col-lg-4 col-md-6 lg-mt-30">
                            <div className="footer__two-widget footer-border pl-60 lg-pl-0">
                                <h4>Recent Post</h4>
                                <div className="all__sidebar-item-post">
                                    {blogData?.slice(0, 2)?.map((data, id) => (
                                        <div className="post__item" key={id}>
                                            <div className="post__item-image">
                                                <Link to={`/blog/${data.id}`}><img src={data.image} alt="image" /></Link>
                                            </div>
                                            <div className="post__item-title">
                                                <span><i className="far fa-calendar-alt"></i>Mar {data.date}, 2025</span>
                                                <h6><Link to={`/blog/${data.id}`}>{data.title}</Link></h6>
                                            </div>
                                        </div>
                                    ))}
                                </div>	
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="copyright__area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="copyright__area-content t-center">
                                <p>Copyright 2025 – All Rights Reserved By <Link to="#" target="_blank">The Engineersbay Ltd</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FooterTwo;